import { render, staticRenderFns } from "./aiChatMange.vue?vue&type=template&id=777156ea&scoped=true"
import script from "./aiChatMange.vue?vue&type=script&lang=js"
export * from "./aiChatMange.vue?vue&type=script&lang=js"
import style0 from "./aiChatMange.vue?vue&type=style&index=0&id=777156ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777156ea",
  null
  
)

export default component.exports